import { UserManager, WebStorageStateStore } from 'oidc-client';
import { authActions } from '../../actions';
import {config} from '../../utils/config';

const authApiUrl = 'https://api.identity.welbee.co.uk';

const authConfig = {
  authority: authApiUrl,
  redirect_uri: config.APP_URL + "/login-redirect",
  response_type: "code",
  scope: "openid profile email",
  post_logout_redirect_uri: config.APP_URL + "/login",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
  automaticSilentRenew: false,
  sessionMonitor: false
};

if (config.APP_URL === 'http://localhost:3002') { 
  authConfig.client_id = 'AdminAppLocal';
} else if (config.APP_URL === 'https://s.admin.welbee.co.uk') {
  authConfig.client_id = 'AdminAppStaging';
} else if (config.APP_URL === 'https://s.ei.welbee.co.uk') {
  authConfig.client_id = 'AdminAppStaging';
} else {
  authConfig.client_id = 'AdminApp';
}

const userManager = new UserManager(authConfig)

export async function loadUserFromStorage(store) {
  try {
    let user = await userManager.getUser();
    if (!user) { return store.dispatch(authActions.storeUserError()); }
    store.dispatch(authActions.storeUser(user));
  } catch (e) {
    console.error(`User not found: ${e}`);
    store.dispatch(authActions.storeUserError());
  }
}

export function signinRedirect() {
  return userManager.signinRedirect();
}

export function signinRedirectCallback() {
  return userManager.signinRedirectCallback();
}

export function signoutRedirect() {
  userManager.clearStaleState();
  userManager.removeUser();
  return userManager.signoutRedirect();
}

export function signoutRedirectCallback() {
  userManager.clearStaleState();
  userManager.removeUser();
  return userManager.signoutRedirectCallback();
}

const userService = {
  userManager,
  loadUserFromStorage,
  signinRedirect,
  signinRedirectCallback,
  signoutRedirect,
  signoutRedirectCallback
};

export default userService